import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width", "className"];
import styled from 'styled-components';
import SkeletonBase from './SkeletonBase';
import { getSize } from './skeletonBaseUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonTextWrapper = styled.div.withConfig({
  displayName: "SkeletonText__SkeletonTextWrapper",
  componentId: "sc-3ajj4i-0"
})(["position:relative;width:", ";"], ({
  width
}) => getSize(width));
const SkeletonTextInner = styled(SkeletonBase).withConfig({
  displayName: "SkeletonText__SkeletonTextInner",
  componentId: "sc-3ajj4i-1"
})(["height:0.75em;left:0;position:absolute;top:50%;transform:translateY(-50%);width:100%;"]);
const SkeletonText = _ref => {
  let {
      width = '100%',
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(SkeletonTextWrapper, {
    width: width,
    className: className,
    children: ["\xA0", /*#__PURE__*/_jsx(SkeletonTextInner, Object.assign({}, rest))]
  });
};
SkeletonText.displayName = 'SkeletonText';
export default SkeletonText;